import { useState, useEffect } from 'react'

import { useBreakpoints } from '@vfuk/core-match-media'

import type { Link } from '../Footer.types'

export const useLinksList = (links: Link[], linksRowLength: number): Link[][] => {
  const [linksList, setLinksList] = useState<Link[][]>([])

  const breakpoints = useBreakpoints()

  const getLinkList = (): void => {
    const linksArray: Link[][] = []

    for (let i = 0; i < links!.length; i += linksRowLength) {
      const subArray = links!.slice(i, i + linksRowLength)
      linksArray.push(subArray)
    }

    setLinksList(linksArray)
  }

  useEffect(() => {
    getLinkList()
  }, [breakpoints, links])

  return linksList
}
